import React, { ReactChild, HTMLAttributes } from 'react'
import uuid from 'uuid/v4';
import { IWithTableProps, TColumnTitle, defaultGrey } from '../../prop-types';
import TableRow from './TableRow';
import TableCell from './TableCell';
import Visible from '../Visible';
import IconButton from '../ActionIcons/IconButton';
import Add from '../svg/Add';

export interface ITableHeadProps extends IWithTableProps{
  title: string;
  columnTitles: TColumnTitle[];
  colSpanLength: number;
  readOnly: boolean;
  toggleIsAddMode: () => void;
}

export default function TableHead(props: ITableHeadProps) {
  const { title, columnTitles, readOnly, toggleIsAddMode, colSpanLength } = props;


  return (
    <thead className="table__head" {...props}>
      <TableRow>
        <TableCell variant="head" colspan={colSpanLength} >
          <h4>{title}</h4>
        </TableCell>
        <Visible if={!readOnly}>
          <TableCell className="borderless right-align">
            <IconButton onClick={() => toggleIsAddMode()}>
              <Add color={defaultGrey}/>
            </IconButton>
          </TableCell>
        </Visible>
      </TableRow>
      <TableRow>
        <Visible if={!readOnly}>
          <TableCell variant='head' style={{ width: "80px" }}>Actions</TableCell>
        </Visible>
        <>
        {columnTitles.map(c => (
          <TableCell variant='head' key={uuid()}>{c}</TableCell>
        ))}
        </>
      </TableRow>
    </thead>
  )
}
